export default {
  "formattingInfo": {
    "zar": {
      "symbol": "R",
      "precision": 2,
      "thousand": " ",
      "decimal": ","
    },
    "etb": {
      "symbol": "ብር",
      "precision": 2,
      "thousand": ",",
      "decimal": "."
    },
    "aed": {
      "symbol": "د.إ.",
      "precision": 2,
      "thousand": "٬",
      "decimal": "٫"
    },
    "bhd": {
      "symbol": "د.ب.",
      "precision": 3,
      "thousand": "٬",
      "decimal": "٫"
    },
    "dzd": {
      "symbol": "د.ج.",
      "precision": 2,
      "thousand": ".",
      "decimal": ","
    },
    "egp": {
      "symbol": "ج.م.",
      "precision": 2,
      "thousand": "٬",
      "decimal": "٫"
    },
    "iqd": {
      "symbol": "د.ع.",
      "precision": 0,
      "thousand": "٬",
      "decimal": "٫"
    },
    "jod": {
      "symbol": "د.أ.",
      "precision": 3,
      "thousand": "٬",
      "decimal": "٫"
    },
    "kwd": {
      "symbol": "د.ك.",
      "precision": 3,
      "thousand": "٬",
      "decimal": "٫"
    },
    "lbp": {
      "symbol": "ل.ل.",
      "precision": 0,
      "thousand": "٬",
      "decimal": "٫"
    },
    "lyd": {
      "symbol": "د.ل.",
      "precision": 3,
      "thousand": ".",
      "decimal": ","
    },
    "mad": {
      "symbol": "د.م.",
      "precision": 2,
      "thousand": ".",
      "decimal": ","
    },
    "omr": {
      "symbol": "ر.ع.",
      "precision": 3,
      "thousand": "٬",
      "decimal": "٫"
    },
    "qar": {
      "symbol": "ر.ق.",
      "precision": 2,
      "thousand": "٬",
      "decimal": "٫"
    },
    "sar": {
      "symbol": "ر.س.",
      "precision": 2,
      "thousand": "٬",
      "decimal": "٫"
    },
    "syp": {
      "symbol": "ل.س.",
      "precision": 0,
      "thousand": "٬",
      "decimal": "٫"
    },
    "tnd": {
      "symbol": "د.ت.",
      "precision": 3,
      "thousand": ".",
      "decimal": ","
    },
    "yer": {
      "symbol": "ر.ي.",
      "precision": 0,
      "thousand": "٬",
      "decimal": "٫"
    },
    "clp": {
      "symbol": "CLP",
      "precision": 0,
      "thousand": ",",
      "decimal": "."
    },
    "inr": {
      "symbol": "₹",
      "precision": 2,
      "thousand": ",",
      "decimal": "."
    },
    "azn": {
      "symbol": "₼",
      "precision": 2,
      "thousand": ".",
      "decimal": ","
    },
    "rub": {
      "symbol": "RUB",
      "precision": 2,
      "thousand": ",",
      "decimal": "."
    },
    "byn": {
      "symbol": "Br",
      "precision": 2,
      "thousand": " ",
      "decimal": ","
    },
    "bgn": {
      "symbol": "лв.",
      "precision": 2,
      "thousand": " ",
      "decimal": ","
    },
    "bdt": {
      "symbol": "৳",
      "precision": 2,
      "thousand": ",",
      "decimal": "."
    },
    "cny": {
      "symbol": "¥",
      "precision": 2,
      "thousand": ",",
      "decimal": "."
    },
    "eur": {
      "symbol": "€",
      "precision": 2,
      "thousand": " ",
      "decimal": ","
    },
    "bam": {
      "symbol": "КМ",
      "precision": 2,
      "thousand": ".",
      "decimal": ","
    },
    "czk": {
      "symbol": "Kč",
      "precision": 2,
      "thousand": " ",
      "decimal": ","
    },
    "gbp": {
      "symbol": "£",
      "precision": 2,
      "thousand": ",",
      "decimal": "."
    },
    "dkk": {
      "symbol": "kr.",
      "precision": 2,
      "thousand": ".",
      "decimal": ","
    },
    "chf": {
      "symbol": "CHF",
      "precision": 2,
      "thousand": "’",
      "decimal": "."
    },
    "mvr": {
      "symbol": "ރ.",
      "precision": 2,
      "thousand": ",",
      "decimal": "."
    },
    "btn": {
      "symbol": "Nu.",
      "precision": 2,
      "thousand": ",",
      "decimal": "."
    },
    "aud": {
      "symbol": "$",
      "precision": 2,
      "thousand": ",",
      "decimal": "."
    },
    "bzd": {
      "symbol": "$",
      "precision": 2,
      "thousand": ",",
      "decimal": "."
    },
    "cad": {
      "symbol": "$",
      "precision": 2,
      "thousand": ",",
      "decimal": "."
    },
    "hkd": {
      "symbol": "HK$",
      "precision": 2,
      "thousand": ",",
      "decimal": "."
    },
    "jmd": {
      "symbol": "$",
      "precision": 2,
      "thousand": ",",
      "decimal": "."
    },
    "myr": {
      "symbol": "RM",
      "precision": 2,
      "thousand": ",",
      "decimal": "."
    },
    "nzd": {
      "symbol": "$",
      "precision": 2,
      "thousand": ",",
      "decimal": "."
    },
    "php": {
      "symbol": "₱",
      "precision": 2,
      "thousand": ",",
      "decimal": "."
    },
    "sgd": {
      "symbol": "$",
      "precision": 2,
      "thousand": ",",
      "decimal": "."
    },
    "ttd": {
      "symbol": "$",
      "precision": 2,
      "thousand": ",",
      "decimal": "."
    },
    "usd": {
      "symbol": "$",
      "precision": 2,
      "thousand": ",",
      "decimal": "."
    },
    "¤¤": {
      "symbol": "¤",
      "precision": 2,
      "thousand": ",",
      "decimal": "."
    },
    "ars": {
      "symbol": "$",
      "precision": 2,
      "thousand": ".",
      "decimal": ","
    },
    "bob": {
      "symbol": "Bs",
      "precision": 2,
      "thousand": ".",
      "decimal": ","
    },
    "cop": {
      "symbol": "$",
      "precision": 2,
      "thousand": ".",
      "decimal": ","
    },
    "crc": {
      "symbol": "₡",
      "precision": 2,
      "thousand": " ",
      "decimal": ","
    },
    "cup": {
      "symbol": "$",
      "precision": 2,
      "thousand": ",",
      "decimal": "."
    },
    "dop": {
      "symbol": "RD$",
      "precision": 2,
      "thousand": ",",
      "decimal": "."
    },
    "gtq": {
      "symbol": "Q",
      "precision": 2,
      "thousand": ",",
      "decimal": "."
    },
    "hnl": {
      "symbol": "L",
      "precision": 2,
      "thousand": ",",
      "decimal": "."
    },
    "mxn": {
      "symbol": "$",
      "precision": 2,
      "thousand": ",",
      "decimal": "."
    },
    "nio": {
      "symbol": "C$",
      "precision": 2,
      "thousand": ",",
      "decimal": "."
    },
    "pab": {
      "symbol": "B/.",
      "precision": 2,
      "thousand": ",",
      "decimal": "."
    },
    "pen": {
      "symbol": "S/",
      "precision": 2,
      "thousand": ",",
      "decimal": "."
    },
    "pyg": {
      "symbol": "Gs.",
      "precision": 0,
      "thousand": ".",
      "decimal": ","
    },
    "uyu": {
      "symbol": "$",
      "precision": 2,
      "thousand": ".",
      "decimal": ","
    },
    "ves": {
      "symbol": "Bs.S",
      "precision": 2,
      "thousand": ".",
      "decimal": ","
    },
    "irr": {
      "symbol": "ریال",
      "precision": 0,
      "thousand": "٬",
      "decimal": "٫"
    },
    "xof": {
      "symbol": "CFA",
      "precision": 0,
      "thousand": " ",
      "decimal": ","
    },
    "cdf": {
      "symbol": "FC",
      "precision": 2,
      "thousand": " ",
      "decimal": ","
    },
    "xaf": {
      "symbol": "FCFA",
      "precision": 0,
      "thousand": " ",
      "decimal": ","
    },
    "htg": {
      "symbol": "G",
      "precision": 2,
      "thousand": " ",
      "decimal": ","
    },
    "ils": {
      "symbol": "₪",
      "precision": 2,
      "thousand": ",",
      "decimal": "."
    },
    "hrk": {
      "symbol": "HRK",
      "precision": 2,
      "thousand": ".",
      "decimal": ","
    },
    "huf": {
      "symbol": "Ft",
      "precision": 2,
      "thousand": " ",
      "decimal": ","
    },
    "amd": {
      "symbol": "֏",
      "precision": 2,
      "thousand": " ",
      "decimal": ","
    },
    "idr": {
      "symbol": "Rp",
      "precision": 2,
      "thousand": ".",
      "decimal": ","
    },
    "ngn": {
      "symbol": "₦",
      "precision": 2,
      "thousand": ",",
      "decimal": "."
    },
    "isk": {
      "symbol": "ISK",
      "precision": 0,
      "thousand": ".",
      "decimal": ","
    },
    "jpy": {
      "symbol": "￥",
      "precision": 0,
      "thousand": ",",
      "decimal": "."
    },
    "gel": {
      "symbol": "₾",
      "precision": 2,
      "thousand": " ",
      "decimal": ","
    },
    "kzt": {
      "symbol": "₸",
      "precision": 2,
      "thousand": " ",
      "decimal": ","
    },
    "khr": {
      "symbol": "៛",
      "precision": 2,
      "thousand": ".",
      "decimal": ","
    },
    "krw": {
      "symbol": "₩",
      "precision": 0,
      "thousand": ",",
      "decimal": "."
    },
    "kgs": {
      "symbol": "сом",
      "precision": 2,
      "thousand": " ",
      "decimal": ","
    },
    "lak": {
      "symbol": "₭",
      "precision": 0,
      "thousand": ".",
      "decimal": ","
    },
    "mkd": {
      "symbol": "ден",
      "precision": 2,
      "thousand": ".",
      "decimal": ","
    },
    "mnt": {
      "symbol": "₮",
      "precision": 2,
      "thousand": ",",
      "decimal": "."
    },
    "bnd": {
      "symbol": "$",
      "precision": 2,
      "thousand": ".",
      "decimal": ","
    },
    "mmk": {
      "symbol": "K",
      "precision": 0,
      "thousand": ",",
      "decimal": "."
    },
    "nok": {
      "symbol": "kr",
      "precision": 2,
      "thousand": " ",
      "decimal": ","
    },
    "npr": {
      "symbol": "नेरू",
      "precision": 2,
      "thousand": ",",
      "decimal": "."
    },
    "pkr": {
      "symbol": "ر",
      "precision": 2,
      "thousand": "٬",
      "decimal": "٫"
    },
    "pln": {
      "symbol": "zł",
      "precision": 2,
      "thousand": " ",
      "decimal": ","
    },
    "afn": {
      "symbol": "؋",
      "precision": 0,
      "thousand": "٬",
      "decimal": "٫"
    },
    "brl": {
      "symbol": "R$",
      "precision": 2,
      "thousand": ".",
      "decimal": ","
    },
    "mdl": {
      "symbol": "L",
      "precision": 2,
      "thousand": ".",
      "decimal": ","
    },
    "ron": {
      "symbol": "RON",
      "precision": 2,
      "thousand": ".",
      "decimal": ","
    },
    "rwf": {
      "symbol": "RF",
      "precision": 0,
      "thousand": ".",
      "decimal": ","
    },
    "sek": {
      "symbol": "kr",
      "precision": 2,
      "thousand": " ",
      "decimal": ","
    },
    "lkr": {
      "symbol": "රු.",
      "precision": 2,
      "thousand": ",",
      "decimal": "."
    },
    "sos": {
      "symbol": "S",
      "precision": 0,
      "thousand": ",",
      "decimal": "."
    },
    "all": {
      "symbol": "Lekë",
      "precision": 0,
      "thousand": " ",
      "decimal": ","
    },
    "rsd": {
      "symbol": "RSD",
      "precision": 0,
      "thousand": ".",
      "decimal": ","
    },
    "kes": {
      "symbol": "Ksh",
      "precision": 2,
      "thousand": ",",
      "decimal": "."
    },
    "thb": {
      "symbol": "฿",
      "precision": 2,
      "thousand": ",",
      "decimal": "."
    },
    "ern": {
      "symbol": "Nfk",
      "precision": 2,
      "thousand": ",",
      "decimal": "."
    },
    "tmt": {
      "symbol": "TMT",
      "precision": 2,
      "thousand": " ",
      "decimal": ","
    },
    "bwp": {
      "symbol": "P",
      "precision": 2,
      "thousand": " ",
      "decimal": "."
    },
    "try": {
      "symbol": "₺",
      "precision": 2,
      "thousand": ".",
      "decimal": ","
    },
    "uah": {
      "symbol": "₴",
      "precision": 2,
      "thousand": " ",
      "decimal": ","
    },
    "uzs": {
      "symbol": "сўм",
      "precision": 2,
      "thousand": " ",
      "decimal": ","
    },
    "vnd": {
      "symbol": "₫",
      "precision": 0,
      "thousand": ".",
      "decimal": ","
    }
  }
}